import { UserRole } from '@p2p/users/domain';

import { RolesPermissions, UserCreateRolesPermissions } from '../entities/roles-permissions';

import { Permissions } from './permissions';

export const rolesPermissions: RolesPermissions = {
    [UserRole.Owner]: [
        Permissions.ViewDashboards,
        Permissions.ViewUsers,
        Permissions.ManageUsers,
        Permissions.ManageDisputes,
        Permissions.ManagePlatformSettings,
        Permissions.ManageUserBalance,
        Permissions.ViewNotifications
    ],
    [UserRole.AccountManagerTrusted]: [
        Permissions.ViewUsers,
        Permissions.ManageUsers,
        Permissions.ManageDisputes,
        Permissions.ManageUserBalance,
        Permissions.ViewNotifications
    ],
    [UserRole.AccountManager]: [
        Permissions.ViewUsers,
        Permissions.ManageUsers,
        Permissions.ManageDisputes,
        Permissions.ViewNotifications
    ],
    [UserRole.Trader]: [
        Permissions.ViewDashboards,
        Permissions.ManagePaymentProfiles,
        Permissions.DepositInfo,
        Permissions.ViewNotifications
    ],
    [UserRole.Operator]: [
        Permissions.ViewDashboards,
        Permissions.ManagePaymentProfiles,
        Permissions.DepositInfo,
        Permissions.ViewNotifications
    ],
    [UserRole.TeamLead]: [Permissions.ViewDashboards, Permissions.ManageTeam, Permissions.ViewNotifications],
    [UserRole.Merchant]: [Permissions.ViewDashboards, Permissions.ManageApi, Permissions.ViewNotifications]
};

export const userCreationRolesPermissions: UserCreateRolesPermissions = {
    [UserRole.Owner]: [
        UserRole.Trader,
        UserRole.Operator,
        UserRole.TeamLead,
        UserRole.AccountManagerTrusted,
        UserRole.AccountManager,
        UserRole.Merchant
    ],
    [UserRole.AccountManagerTrusted]: [
        UserRole.Trader,
        UserRole.Operator,
        UserRole.TeamLead,
        UserRole.AccountManager,
        UserRole.Merchant
    ],
    [UserRole.AccountManager]: [UserRole.Trader, UserRole.Operator, UserRole.TeamLead],
    [UserRole.Trader]: [],
    [UserRole.Operator]: [],
    [UserRole.TeamLead]: [],
    [UserRole.Merchant]: []
};
